const INIT_STATE = {};

export default function stickyReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case `@oms/STICK_STATE`: {
      return {
        ...state,
        [action.key]: action.value,
      };
    }
    default:
      return state;
  }
}
